import { useMemo } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIDropdownDivider from 'UIComponents/dropdown/UIDropdownDivider';
import UIList from 'UIComponents/list/UIList';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { CONTENT_MANAGEMENT_ACTION } from 'ContentEditorUI/constants/contentManagement';
import useContentManagementTableRowActions from 'ContentEditorUI/hooks/useContentManagementTableRowActions';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const ACTIONS = [['EDIT', 'CLONE', 'DELETE'], ['VIEW', 'DETAILS', 'SHARE']];
const ActionButton = ({
  content,
  actionHandler,
  actionName,
  disabledData = {
    disabled: false,
    disabledTooltipTitle: '',
    disabledTooltipOptions: {}
  }
}) => {
  const actionButton = useMemo(() => {
    const onClick = e => {
      e.stopPropagation();
      UsageTracker.trackAsBeacon('editorInteraction', {
        action: CONTENT_MANAGEMENT_ACTION,
        event: `clicked-content-action--${actionName}`
      });
      return actionHandler(content.id, e);
    };
    return /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": `row-action-${actionName}-${content.id}`,
      disabled: disabledData ? disabledData.disabled : false,
      onClick: onClick,
      size: "extra-small",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `contentManagementPanel.table.contentActions.${actionName}`
      })
    }, actionName);
  }, [actionHandler, content, actionName, disabledData]);
  return disabledData.disabled ? /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: disabledData.disabledTooltipTitle,
      options: disabledData.disabledTooltipOptions
    }),
    placement: "right bottom",
    children: actionButton
  }) : actionButton;
};
const ContentActionsDropdown = ({
  content,
  openModal
}) => {
  const {
    actions,
    disabledActions
  } = useContentManagementTableRowActions({
    content,
    openModal
  });
  return /*#__PURE__*/_jsx(UIDropdown, {
    "data-test-id": `row-actions-${content.id}`,
    buttonClassName: "p-x-2",
    buttonText: I18n.text('contentManagementPanel.table.contentActions.actionsButton'),
    buttonSize: "xs",
    menuWidth: "auto",
    placement: "bottom left",
    children: /*#__PURE__*/_jsx(UIList, {
      children: ACTIONS.map((actionGroup, index) => {
        const actionsForGroup = actionGroup.reduce((acc, actionName) => {
          const actionHandler = actions[actionName];
          if (actionHandler) {
            acc.push( /*#__PURE__*/_jsx(ActionButton, {
              content: content,
              actionName: actionName,
              actionHandler: actionHandler,
              disabledData: disabledActions[actionName]
            }, `content-row-${content.id}-${actionName}`));
          }
          return acc;
        }, []);
        if (index < ACTIONS.length - 1) {
          actionsForGroup.push( /*#__PURE__*/_jsx(UIDropdownDivider, {}));
        }
        return actionsForGroup;
      })
    })
  });
};
export default ContentActionsDropdown;